import React from 'react';
import { Link } from 'react-router-dom';
import { supplierBenefits } from '../mockData';
import { CheckCircle, DollarSign, Award, Users, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';

const ForSuppliers = () => {
  return (
    <div style={{ backgroundColor: '#1a1c1b', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section style={{
        padding: '120px 40px 80px',
        backgroundColor: '#302f2c',
        borderBottom: '1px solid rgba(63, 72, 22, 0.5)'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            lineHeight: 0.95,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '24px'
          }}>
            For Suppliers
          </h1>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.5rem',
            lineHeight: 1.5,
            color: '#dfddd6',
            maxWidth: '50rem',
            margin: '0 auto 32px'
          }}>
            Grow Your Business Through Guaranteed Opportunities
          </p>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.1rem',
            lineHeight: 1.6,
            color: '#888680',
            maxWidth: '45rem',
            margin: '0 auto'
          }}>
            Worklink Global partners with subcontractors and labour providers seeking consistent workflow, reliable payments, and access to larger corporate projects.
          </p>
        </div>
      </section>

      {/* What We Offer Suppliers */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#1a1c1b'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '48px',
            textAlign: 'center'
          }}>
            We Offer Suppliers
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px'
          }}>
            {supplierBenefits.map((benefit, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: '#302f2c',
                  padding: '24px',
                  borderRadius: '8px',
                  border: '1px solid rgba(63, 72, 22, 0.5)',
                  transition: 'background-color 0.3s ease',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3f4816'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#302f2c'}
              >
                <CheckCircle size={24} style={{ color: '#d9fb06', flexShrink: 0, marginTop: '2px' }} />
                <p style={{
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: '1rem',
                  color: '#dfddd6',
                  margin: 0,
                  lineHeight: 1.5
                }}>
                  {benefit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Benefits Highlighted */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#302f2c'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '48px',
            textAlign: 'center'
          }}>
            Why Partner With Us?
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px'
          }}>
            {[
              {
                icon: DollarSign,
                title: 'Weekly Payments',
                description: 'Reliable, consistent cash flow with weekly payment cycles to support your business operations.'
              },
              {
                icon: TrendingUp,
                title: 'Guaranteed Jobs',
                description: 'Access to ongoing project pipelines across multiple industries and major corporate clients.'
              },
              {
                icon: Users,
                title: 'Major Client Access',
                description: 'Work with Tier 1, Tier 2, and government clients through our established network.'
              },
              {
                icon: Award,
                title: 'Long-Term Partnership',
                description: 'Build a sustainable business relationship with dedicated relationship management and support.'
              }
            ].map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#1a1c1b',
                    padding: '40px',
                    borderRadius: '8px',
                    border: '1px solid rgba(63, 72, 22, 0.5)',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <IconComponent size={48} style={{ color: '#d9fb06', marginBottom: '20px' }} />
                  <h3 style={{
                    fontFamily: 'Arial, sans-serif',
                    fontWeight: 700,
                    fontSize: '1.3rem',
                    color: '#d9fb06',
                    marginBottom: '16px',
                    textTransform: 'uppercase'
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: '1rem',
                    lineHeight: 1.6,
                    color: '#dfddd6'
                  }}>
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* What We Expect */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#1a1c1b'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '32px',
            textAlign: 'center'
          }}>
            What We Expect from Suppliers
          </h2>
          <div style={{
            backgroundColor: '#302f2c',
            padding: '48px',
            borderRadius: '8px',
            border: '1px solid rgba(63, 72, 22, 0.5)'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                'Valid licences and trade qualifications',
                'Insurance compliance (WC + PL)',
                'English proficiency',
                'Police checks and required vaccinations',
                'WHS training currency',
                'Professional conduct and reliable delivery'
              ].map((requirement, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#1a1c1b',
                    padding: '20px',
                    borderRadius: '8px',
                    border: '1px solid rgba(63, 72, 22, 0.5)',
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3f4816'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a1c1b'}
                >
                  <p style={{
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: '1rem',
                    color: '#dfddd6',
                    margin: 0
                  }}>
                    • {requirement}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Registration Requirements */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#302f2c'
      }}>
        <div style={{
          maxWidth: '60rem',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '32px'
          }}>
            Registration Requirements
          </h2>
          <div style={{
            backgroundColor: '#1a1c1b',
            padding: '40px',
            borderRadius: '8px',
            border: '1px solid rgba(63, 72, 22, 0.5)',
            textAlign: 'left'
          }}>
            <ul style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: '1.1rem',
              lineHeight: 2,
              color: '#dfddd6',
              paddingLeft: '24px',
              margin: 0
            }}>
              <li>Company details and ABN</li>
              <li>Workers' compensation and public liability insurance</li>
              <li>Licences and trade certifications</li>
              <li>Supervisor details</li>
              <li>WHS documentation</li>
              <li>Police checks (where applicable)</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#3f4816',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '60rem',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            marginBottom: '24px',
            textTransform: 'uppercase'
          }}>
            Join Our Network
          </h2>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.25rem',
            lineHeight: 1.6,
            color: '#dfddd6',
            marginBottom: '40px'
          }}>
            Partner with Worklink Global and grow your business with guaranteed opportunities
          </p>
          <Link to="/contact?form=supplier" style={{ textDecoration: 'none' }}>
            <Button
              style={{
                background: '#d9fb06',
                color: '#1a1c1b',
                border: 'none',
                borderRadius: '10rem',
                padding: '1.2em 2em',
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              Become a Supplier
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ForSuppliers;
